import { styled, css } from 'styled-components';

import TextBlock from 'components/TextBlock';
import { styleBodyL, styleHeadingL, styleLabelS } from 'style/components/Typography';
import { columnGap } from 'style/grid';
import { scrollMarginTopPad } from 'style/headerOffsets';
import { MQ } from 'style/mediaQueries';

export const Container = styled.div`
    ${columnGap};
    display: grid;
    grid-auto-rows: auto;
    grid-template-columns: repeat(4, 1fr);
    ${scrollMarginTopPad};

    ${MQ.FROM_M} {
        grid-template-columns: repeat(8, 1fr);
    }

    ${MQ.FROM_XL} {
        grid-template-columns: repeat(7, 1fr);
    }
`;

export const PreHeading = styled.span`
    ${styleLabelS};
    grid-column: 1 / span 4;
    margin-bottom: 0.4375rem;

    ${MQ.FROM_M} {
        grid-column: 1 / span 8;
    }

    ${MQ.FROM_L} {
        grid-column: 1 / span 6;
    }

    ${MQ.FROM_XL} {
        grid-column: 1 / span 5;
    }
`;

export const Heading = styled.h2`
    ${styleHeadingL};
    grid-column: 1 / span 4;
    margin-bottom: 0.875rem;
    margin-top: 0;

    ${MQ.FROM_M} {
        grid-column: 1 / span 8;
        margin-bottom: 1.3125rem;
    }

    ${MQ.FROM_L} {
        grid-column: 1 / span 6;
    }

    ${MQ.FROM_XL} {
        grid-column: 1 / span 5;
        margin-bottom: 1.75rem;
    }
`;

const introductionStyle = css`
    ${styleBodyL};
    grid-column: 1 / span 4;
    margin-bottom: 0.875rem;

    ${MQ.FROM_M} {
        grid-column: 1 / span 8;
        margin-bottom: 1.3125rem;
    }

    ${MQ.FROM_L} {
        grid-column: 1 / span 6;
    }

    ${MQ.FROM_XL} {
        grid-column: 1 / span 5;
        margin-bottom: 1.75rem;
    }
`;

export const Introduction = styled.div`
    ${introductionStyle}
`;

export const IntroductionHtml = styled(TextBlock)`
    ${introductionStyle}
`;

export const Authors = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.75rem;
    grid-column: 1 / span 4;
    margin-bottom: 0.875rem;

    ${MQ.FROM_M} {
        grid-column: 1 / span 8;
        margin-bottom: 1.3125rem;
    }

    ${MQ.FROM_L} {
        grid-column: 1 / span 6;
    }

    ${MQ.FROM_XL} {
        grid-column: 1 / span 5;
        margin-bottom: 2.1875rem;
    }
`;

export const Content = styled(TextBlock)`
    grid-column: 1 / span 4;
    margin-top: 0.875rem;

    ${MQ.FROM_M} {
        grid-column: 1 / span 8;
        margin-top: 0.4375rem;
    }

    ${MQ.FROM_L} {
        grid-column: 1 / span 8;
    }

    ${MQ.FROM_XL} {
        margin-top: 0.875rem;
    }
`;
